import { img } from "@/lib/images";

// Alle Bilder der Villen-Übersichtsseite liegen einheitlich in
// villas/villa-gallery/ – pro Foto eine Datei: villa-gallery-NN.jpg
//
// Nummerierung (Stand: 25 Plätze):
//   01–12  Villa Hibiskus
//   13–18  Villa Frangipani
//   19–24  Villa Bougainvillea
//   25     Villa Kompiang
//
// Die Texte entsprechen exakt den im Backstage gepflegten Beschriftungen
// (Deutsch = caption, Englisch = captionEn).
const g = (num: string, caption: string, captionEn: string) => ({
  key: `villas/villa-gallery/villa-gallery-${num}.jpg`,
  thumb: img(`villas/villa-gallery/villa-gallery-${num}.jpg`),
  full: img(`villas/villa-gallery/villa-gallery-${num}.jpg`),
  caption,
  captionEn,
});

export const villaGalleryImages = [
  // Villa Hibiskus
  g("01", "Villa Hibiskus - Haupteingang", "Villa Hibiscus - Main Entrance"),
  g("02", "Villa Hibiskus - Pool", "Villa Hibiscus - Pool"),
  g("03", "Villa Hibiskus - Eingangshalle", "Villa Hibiscus - Entrance Hall"),
  g("04", "Villa Hibiskus - Eingangshalle", "Villa Hibiscus - Entrance Hall"),
  g("05", "Villa Hibiskus - Küche", "Villa Hibiscus - Kitchen"),
  g("06", "Villa Hibiskus - Essterrasse", "Villa Hibiscus - Dining Terrace"),
  g("07", "Villa Hibiskus - Schlafzimmer 1", "Villa Hibiscus - Bedroom 1"),
  g("08", "Villa Hibiskus - Schlafzimmer 1", "Villa Hibiscus - Bedroom 1"),
  g("09", "Villa Hibiskus - Schlafzimmer 2", "Villa Hibiscus - Bedroom 2"),
  g("10", "Villa Hibiskus - Schlafzimmer 2", "Villa Hibiscus - Bedroom 2"),
  g("11", "Villa Hibiskus - Schlafzimmer 3", "Villa Hibiscus - Bedroom 3"),
  g("12", "Villa Hibiskus - Schlafzimmer 3", "Villa Hibiscus - Bedroom 3"),
  // Villa Frangipani
  g("13", "Villa Frangipani - Terrasse", "Villa Frangipani - Terrace"),
  g("14", "Villa Frangipani - Terrasse", "Villa Frangipani - Terrace"),
  g("15", "Villa Frangipani - Schlafzimmer 1", "Villa Frangipani - Bedroom 1"),
  g("16", "Villa Frangipani - Badezimmer", "Villa Frangipani - Bathroom"),
  g("17", "Villa Frangipani - Badezimmer", "Villa Frangipani - Bathroom"),
  g("18", "Villa Frangipani - Schlafzimmer 2", "Villa Frangipani - Bedroom 2"),
  // Villa Bougainvillea
  g("19", "Villa Bougainvillea - Terrasse", "Villa Bougainvillea - Terrace"),
  g("20", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  g("21", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  g("22", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  g("23", "Villa Bougainvillea - Badezimmer", "Villa Bougainvillea - Bathroom"),
  g("24", "Villa Bougainvillea - Terrasse", "Villa Bougainvillea - Terrace"),
  // Villa Kompiang
  g("25", "Villa Kompiang - Pool", "Villa Kompiang - Pool"),
];